<template>
  <div class="native-web-push">
    <DelaySettings :disable="true" :delay="delay_value" v-model="delay_value" :min="0" :max="60" :variable="{ key: 's' }" :title="'platform.settings.delay'" :description="'platform.settings.description.native_web_push.delay_settings'" />
    <DelaySettings :disable="true" :delay="blackout_range" v-model="blackout_range" :min="0" :max="100" :variable="{ key: 's' }" :title="'platform.settings.blackout_range'" :description="'platform.settings.description.native_web_push.blackout_settings'" />
    <BlackoutSettings :disabled="true" :text="blackout_text" :title="blackout_title" @setTitle="setBlackoutTitle" @setText="setBlackoutText" />
    <SubscriptionRequest :disabled="true" :subscription="checkSubscription" />
    <DisplaySettings :disabled="true" :checkboxOnly="true" :displaySettings="displaySettings" :disableOsVersions="osVersions" />
  </div>
</template>

<script>
import DelaySettings from "@/components/PlatformSettings/DelaySettings.vue";
import BlackoutSettings from "@/components/PlatformSettings/BlackoutSettings.vue";
import SubscriptionRequest from "@/components/PlatformSettings/SubscriptionRequest.vue";
import DisplaySettings from "@/components/PlatformSettings/DisplaySettings.vue";

export default {
  name: "NativeWebPush",
  components: {
    DelaySettings,
    BlackoutSettings,
    SubscriptionRequest,
    DisplaySettings,
  },
  data() {
    return {
      delay_value: 0,
      blackout_range: 0,
      blackout_title: "",
      blackout_text: "",
      checkSubscription: false,
      displaySettings: {
        disableDeviceSell: [],
        disableOsSell: [],
        notShowReff: false,
        disableYandex: false,
      },
      osVersions: [],
    };
  },
  methods: {
    setBlackoutTitle(val) {
      this.blackout_title = val;
    },
    setBlackoutText(val) {
      this.blackout_text = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
